import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'terra-investing-entity-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [],
  template: `
    <mat-nav-list>
      <button mat-menu-item *ngFor="let item of context.menu" class="edit-share-menu-item"
        (click)="open($event, item.action)">
        <mat-icon color="primary" fontSet="material-icons-outlined">{{item.icon}}</mat-icon>
        <span>{{item.text}}</span>
      </button>
    </mat-nav-list>
  `,
})
export class InvestingEntityMenuComponent {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<InvestingEntityMenuComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public context
  ) {}

  open(event: MouseEvent, res: string): void {
    this._bottomSheetRef.dismiss(res);
    event.preventDefault();
  }
}
